import React from "react";
import { Box, Flex, Skeleton, VStack, Text } from "@chakra-ui/react";
import ItemRow from "components/Transaction/ItemRow";

const SPACING = 4;

/**
 * TxnDetailsSkeletons
 * @returns JSX.Element
 * @description
 * skeletons for TxnDetails
 */
export default function TxnDetailsSkeletons() {
  return (
    <div data-testid="txn-details-skeletons">
      <Box
        p={4}
        pb={0}
        backgroundColor="lightBackground"
        borderY="1px solid"
        borderColor="lightBorder"
      >
        <VStack pt={10} pb={4}>
          <Flex direction="column" align="center">
            <Skeleton width="60px" height="60px" />
            <Box textAlign="center">
              <Skeleton>
                <Text mt={2} fontSize="xl">
                  You received XXX X.XX
                </Text>
              </Skeleton>
            </Box>
          </Flex>
          <Box pt={4} w="100%">
            <Box pt={4}>
              <VStack align="left" spacing={SPACING}>
                <ItemRow title="Line item" value="XXX X.XX" isSkeleton />
                <ItemRow title="Line item" value="XXX X.XX" isSkeleton />
                <ItemRow title="Subtotal" value="XXX X.XX" isSkeleton />
                <ItemRow
                  title="Total"
                  value="XXX X.XX"
                  boldTitle
                  boldValue
                  showBottomBorder={false}
                  isSkeleton
                />
              </VStack>
            </Box>
          </Box>
        </VStack>
      </Box>
      <Box p={4} pl={8}>
        <Box pt={4}>
          <VStack align="left" spacing={SPACING}>
            <Skeleton>
              <Text fontSize="sm" fontWeight="semibold">
                Paid with
              </Text>
            </Skeleton>
            <ItemRow title="Subtotal" value="XXX X.XX" isSkeleton showBottomBorder={false} />
          </VStack>
        </Box>
      </Box>
      <Box p={4} pl={8}>
        <Box pt={4} mb={2}>
          <VStack align="left" spacing={SPACING}>
            <Skeleton>
              <Text fontSize="sm" fontWeight="semibold">
                Invoice details
              </Text>
            </Skeleton>
            <ItemRow title="Status" value="Pending" isSkeleton />
            <ItemRow title="Transaction ID" value="Pending" isSkeleton />
            <ItemRow title="Account ID" value="Pending" isSkeleton />
            <ItemRow title="Transaction Time" value="Pending" isSkeleton showBottomBorder={false} />
          </VStack>
        </Box>
      </Box>
      <Box p={4}>
        <Skeleton width="100%" height="40px" />
        <Skeleton width="100%" height="40px" mt={4} />
      </Box>
    </div>
  );
}
